import React, { Component } from 'react';
import MockAPI from "../../mocks/MockAPI";
import { Grid, Row, Col } from "react-bootstrap";
import Card from '../../components/Card';
import "./Home.css";


export default class Home extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      featuredProjects: []
    }
  }

  async componentDidMount() {
    try {
      const featured = await this.getFeaturedProjects();
      this.setState({
        featuredProjects: featured,
        loading: false
      });
    } catch (e) {
      alert(e);
    }
  }

  async getFeaturedProjects() {
    this.setState({ loading: true });
    let featured = await MockAPI.getFeatured();
    return featured;
  }

  render() {

    if (this.state.loading) {
      return (<div>... loading...</div>)
    }
    else {
      return (
        <Grid>
          <Row className="HomeWelcomeRow">

            <Col md={4} className="HomeWelcomeCol">
              <div className="HomeWelcomeCol__Photo">
                <img src="/images/juliuspopa_profile_photo_1.png" alt="" title="Julius Popa profile photo. Web designer, developer, and creator from Calgary, Alberta." />
              </div>
              <div className="HomeWelcomeCol__Heading">
                <strong>Thank you for your interest in my work</strong>
              </div>
              <div className="HomeWelcomeCol__Subheading">Please feel free to browse my portfolio <br />
                {/* <small>
                  (powered by
              <span className="HomeWelcomeCol__React"> <FontAwesomeIcon icon={faReact} />
                    React</span>
                  )
              </small> */}
              </div>
            </Col>

            <Col md={8}>
              <Row className="HomeRecentProjectsRow">
                <Col md={11} mdOffset={1}>
                  <div className="HomeRecentProjects__Heading">
                    Featured projects
                </div>
                </Col>
              </Row>

              <Row className="HomeRecentProjectsRow">

                {this.state.featuredProjects.map((project) => {
                  return (
                    <Col md={5} mdOffset={1} key={project.id}>
                      <Card project={project} />
                    </Col>
                  )
                })}

              </Row>
            </Col>

          </Row>
        </Grid>
      );
    }
  }
}


// WEBPACK FOOTER //
// ./src/containers/Home/Home.js